import { Col, Row, T2 } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledTile, StyledDocumentsIcon } from './NoDocuments.styles';

export interface NoDocumentsProps { }

const NoDocuments: FC<NoDocumentsProps> = () => {
  const { t } = useTranslation('Documents');

  return (
    <Row>
      <Col>
        <StyledTile isDivided={false}>
          <StyledDocumentsIcon />
          <T2>{t('noDocuments')}</T2>
        </StyledTile>
      </Col>
    </Row>
  );
};

export default NoDocuments;
